<template>
  <div class="m1-4">
    <div class="flex flex-wrap">

      <div class="w-1/5 decrease hover:bg-red-300 h-16 flex rounded-tr-2xl rounded-br-2xl self-center"
           @click="decrement">
        <div v-if="value > 0" class="select-none self-center text-center w-full font-extrabold text-black">-</div>
        <div v-else class="text-xs text-gray-700 select-none self-center text-center w-full">
          🗑️
        </div>
      </div>
      <div class="flex flex-wrap w-3/5 justify-center items-center">
        <p v-if="!config.directInput" class="font-bold text-3xl p-0">{{ value }}</p>
        <p v-else class="font-bold text-3xl p-0"><input max="400" type="number" v-model="value"
                                                        style="text-align:right; width:70px; border: none"></p>
        <p class="text-xl p-0">
          <slot name="after-value"></slot>
        </p>

        <span class="w-full display-block font-hairline text-xs text-gray-400 text-center p-0">{{ config.label }}
          <slot name="sublabel"></slot>
        </span>
      </div>
      <div class="w-1/5 increase hover:bg-green-300 h-16 flex rounded-tl-2xl rounded-bl-2xl self-center"
           @click="increment">
        <div class="select-none self-center text-center w-full font-extrabold text-black">+</div>
      </div>
    </div>
  </div>
</template>

<script>

import {defineComponent} from 'vue';

export default defineComponent({
  name: "counter",
  props: {
    config: {
      type: Object,
      required: true
    }
  },

  created() {
    this.value = this.config.start;
  },

  data() {
    return {
      value: 0
    }
  },

  methods: {
    increment() {

      if (this.value < this.config.max) {
        this.value += this.config.stepSize;
        this.$emit('incremented', this.value);
        return;
      }

      this.$emit('above-maximum-attempt')
    },

    decrement() {

      if (this.value > this.config.min) {
        this.value -= this.config.stepSize;
        this.$emit('decremented', this.value);
        return;
      }

      console.log("below min");
      this.$emit('below-minimum-attempt')

    }
  }

});
</script>

<style scoped>
.increase {
  background-color: #bde280
}

.increase:hover {
  background-color: #aacd71 !important;
}

.decrease {
  background-color: #f98f83;
}

.decrease:hover {
  background-color: #fb6b5b !important;
}
</style>